import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIService } from '../api.service';
import { InfoMessageItem } from '../../models/infomessage';
import { ReturnObject } from '../../models/returnObject';

@Injectable()
export class InfoMessageService {

    constructor(private api: APIService) {
    }

    setInfoMessage(fromDate: Date, toDate: Date, urgency: string, infoMsg: string, header: string): Observable<ReturnObject<string>> {
        const infoMessage = new InfoMessageItem();
        infoMessage.activateDate = fromDate;
        infoMessage.deActivateDate = toDate;
        infoMessage.importance = Number(urgency);
        infoMessage.message = infoMsg;
        infoMessage.header = header;
        return this.api.postAPI('infomessage', infoMessage);
      }

    getmessages(): Observable<ReturnObject<InfoMessageItem[]>> {
        return this.api.getAPI('infomessage');
    }

    getActiveAndScheduledMessages(): Observable<ReturnObject<InfoMessageItem[]>> {
        return this.api.getAPI('infomessage/activeandscheduled');
    }

    deleteMessage(id: number): Observable<ReturnObject<string>>{
        return this.api.deleteByEnpointApi(`infomessage/${id}`);
    }
}
